<template>
  <div class="view">
    <RouterView v-if="currentExport && study" v-slot="{ Component }" class="export-view">
      <Transition name="fade" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isFetching', 'currentExport', 'study']),
  },

  created() {
    if (!this.studyExport) {
      const id = this.$route.params.studyId;

      this.$store.dispatch('getExport', { id }).then(data => {
        const id = data.study_public_id;
        this.$store.dispatch('getStudyResult', { id });
      });
    }
  },

  beforeUnmount() {
    this.$store.dispatch('getStudy');
    this.$store.dispatch('clearExport');
  },
};
</script>

<style lang="scss">
.export-view {
  background-color: #f9f9f9;
  .header-container {
    background-color: #f9f9f9;
    padding-top: 65px;
    padding-bottom: 27px;
    h2 {
      font-size: 32px;
      font-weight: 600;
      color: #3c3c3b;
      line-height: 1.25;
    }
  }
  .form-container {
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #ffffff;
    box-shadow: 0 2px 9px rgba(0, 0, 0, 0.1);

    h3 {
      font-size: 20px;
      font-weight: 600;
    }
  }
  .view-gabarit {
    color: #3c3c3b;
    height: auto;
    max-width: 1152px;
    margin: auto;
    box-sizing: border-box;
    padding-left: 14px;
    padding-right: 14px;
  }
  .form-gabarit {
    display: flex;
    padding-bottom: 45px;
    flex: 1;
  }
  .form-block {
    flex: 1;
  }
  .view-content {
    display: flex;
    .fieldset {
      margin-left: 24px;
      margin-right: 24px;
      padding-left: 12px;
      padding-right: 12px;
      & + .fieldset {
        margin-top: 1.5em;
        padding-top: 1em;
        border-top: 1px solid #e3e3e3;
      }
    }
    fieldset {
      &.site-gabarit {
        padding-top: 17px;
        padding-bottom: 7px;
        padding-left: 10px;
        border-top: 1px solid #e3e3e3;
      }
    }
    .subtitle {
      font-size: 14px;
      font-weight: 900;
      margin-top: 0;
    }
    label {
      font-size: 14px;
      color: #3c3c3b;
      line-height: 1.15;
      margin-bottom: 0;
      span {
        display: block;
        font-size: 14px;
        color: #77797f;
      }
      i {
        display: block;
        color: #9d9c9c;
        font-size: 11px;
        margin-top: 0.5em;
      }
    }
  }
  .details-box {
    width: 33%;
  }
  .cta-container {
    display: flex;
    justify-content: flex-end;
    .study-button {
      & + .study-button {
        margin-left: 1em;
      }
    }
  }
}
</style>
